<template>
  <div>
    <div class="main-container">
      <div
        class="page-heading d-flex align-items-center justify-content-between"
      >
        <div class="d-flex">
          <img src="../../assets/bckarrow.svg" alt="" @click="goBack" />

          <div class="main-head ml-4">
            <span>Share appointment letter</span>
          </div>
        </div>

        <b-button class="addbtn" @click="sendAppointment()">Send</b-button>
      </div>
      <div class="template-container">
        <div class="template-sub-container">
          <div class="pl-5 pr-5 apoint-template-left-container-cards">
            <div
              class="d-flex justify-content-center"
              v-for="(letters, index) in appointmentLetters"
              :key="index"
            >
              <div
                class="template-background-appointment pl-4 pr-4 pt-3 pb-3 mt-3"
              >
                <div class="template-card" v-html-safe="letters.html"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getAppointLetter,
  sendDocsToCandidate,
} from "../../utils/apiFunctions";
export default {
  data() {
    return {
      // ARRAYS
      appointmentLetters: [],
    };
  },
  created() {
    this.getAppointLetter();
  },
  methods: {
    // ASYNCHRONOUS FUNCTION ---- START
    // GET APPOINTMENT LETTER TEMPLATES
    async getAppointLetter() {
      try {
        let payload = {
          candidateID: this.$route.params.candidateID,
          template: 1,
        };
        const response = await getAppointLetter(payload);
        if (response.status == 200) {
          this.appointmentLetters = response.data.data;
        }
      } catch (error) {
        throw new Error(`Failed! status:${error.status}`);
      }
    },
    async sendAppointment() {
      let payload = {
        candidateID: this.$route.params.candidateID,
        action: "A",
        remarks: "",
      };
      const res = await sendDocsToCandidate(payload);
      if (res.status == 200) {
        this.$router.push({
          name: this.$route.query.redirect,
        });
      }
    },
    // ASYNCHRONOUS FUNCTION ---- END

    // HELPER FUNCTIONS ---- START
    // HELPER FUNCTION FOR NAVIGATIONS ---- START
    goBack() {
      this.$router.push({
        name: this.$route.query.redirect,
      });
    },
    // HELPER FUNCTION FOR NAVIGATIONS ---- END
  },
};
</script>

<style>
.template-card {
  background: white;
}
.template-background {
  background: #f3f3f3;
  border-radius: 9.51957px;
}
.template-left-container-cards {
  overflow: auto;
  height: calc(100vh - 250px);
}
.template-sub-container {
  background: #ffffff;
  border-radius: 8px;
  width: 100%;
  box-shadow: 0px 0px 14px rgb(196 196 196 / 50%);
  overflow: auto;
  height: calc(100vh - 165px);
}

.template-container {
  border-radius: 8px;
  padding: 15px;
}
.template-background-appointment {
  background: #f3f3f3;
  border-radius: 9.51957px;
  width: 50%;
}
.apoint-template-left-container-cards {
  overflow: auto;
  height: calc(100vh - 165px);
}
</style>
